<template>
<div class="chapter">
<div class="inner_page">
<div class="SOM">
<h1 class="SOM_titre">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">General preface</a></div>
<div class="SOM_pre"><a href="#/pre3">Author’s preface</a></div>
<div class="SOM_pre"><a href="#/pre4">Chief abbreviations</a></div>
<div class="SOM_pre"><a href="#/pre5">Bibliography</a></div>
<div class="SOM_pre"><a href="#/pre6">Introduction</a></div>
<div class="SOM_chap"><a href="#/chap1">1. Hannah: the powerless woman (1 Samuel 1–4)</a></div>
<div class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample">2. Samuel: the reluctant kingmaker (1 Samuel 4–8)</span></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample">3. Saul: majesty and mania (1 Samuel 9– 15)</span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample">4. David: the young ‘pretender’ (1 Samuel 16– 24)</span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample">5. David: the exiled nationalist (1 Samuel 25– 31)</span></div>
<div class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample">6. David: in control (2 Samuel 1–5)</span></div>
<div class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample">7. David: in covenant (2 Samuel 6–10)</span></div>
<div class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample">8. David: out of control? (2 Samuel 11–13)</span></div>
<div class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample">9. Absalom: a usurping son (2 Samuel 14–20)</span></div>
<div class="SOM_chap"><span href="#/chap10" title="Link target outside of Sample">10. Filling in the gaps? (2 Samuel 21–24)</span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">Map: 1 and 2 Samuel: places and peoples</span></div>
<div class="SOM_appen"><span href="#/appen11" title="Link target outside of Sample">BST Old Testament series</span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample">BST New Testament series</span></div>
<div class="SOM_appen"><span href="#/appen10" title="Link target outside of Sample">BST Bible Themes series</span></div>
<div class="SOM_appen"><span href="#/appen12" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_appen"><span href="#/appen13" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
<div class="SOM_pdf"><span href="#/ident11#copy1" title="Link target outside of Sample">Copyright</span></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?23e8f4f9